export const EDITOR_LIMITS = {
  messageLength: 20000,
  fileBytes: 20 * 1024 * 1024,
  files: 20,
  titleLength: 200,
  messagePageSize: 100,
} as const;

export const EDITOR_POLL_INTERVAL = {
  active: 2500,
  files: 3000,
  idle: 10000,
} as const;

/**
 * Bottom padding inside the review panes' scroll areas.
 *
 * The support launcher floats over the bottom right of the window, 54px square
 * with its top 66px above the viewport's bottom edge. Without this the last
 * lines of the rules, and the last roster rows, could not be scrolled clear of
 * it. It is padding inside the scrolled content, not a margin under the pane,
 * so the pane still fills its column.
 */
export const PANE_BOTTOM_CLEARANCE = "pb-20";

/**
 * The second level of the artifact header.
 *
 * Level one is the tab strip, which says which artifact you are looking at.
 * Level two is that artifact's own controls: the period and the run button on
 * Pay, the edit count and the way through it on Rules, the roster counts on
 * Roster. Both are the editor's chrome, so both sit on the editor's ground,
 * and the white artifact starts underneath them and runs flush to every edge.
 *
 * `min-h-10` is a floor, not a height. The row's contents decide how tall it
 * is, and they differ per pane: Rules, Pay and Access carry a 28px control,
 * the roster carries only text when nothing on it changed. That made the band
 * 42px on three tabs and 26px on the fourth, so moving to Roster shifted the
 * whole sheet up by 16px and back down on the way out. A floor rather than a
 * fixed height, because a narrow pane still wraps these rows onto a second
 * line and has to be allowed to grow.
 *
 * The padding is `py-1` so that floor actually governs. At `py-1.5` a 28px
 * control came to 42px with the border, clearing the 40px floor, so the rows
 * carrying one were 42 and the text-only roster row was 40 — the same 2px
 * disagreement the floor was added to remove, just smaller.
 */
export const ARTIFACT_CONTROLS =
  "flex min-h-10 items-center border-b-2 border-stroke-tertiary bg-gray-10 px-3 py-1 text-sm";
